import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgQuickTipWhite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 15a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z"
      fill="#fff"
    />
    <path
      d="m7.233 8.965.671-.286c-.187-.143-.297-.363-.297-.539 0-1.078 2.134-1.221 2.134-2.882 0-.946-.814-1.705-2.156-1.705-1.045 0-1.859.44-2.387 1.122l.55.594c.407-.539.924-.902 1.749-.902.869 0 1.298.473 1.298 1.023 0 1.166-1.991 1.287-1.991 2.684 0 .33.132.638.429.891Zm.231 2.145a.61.61 0 0 0 .605-.605.61.61 0 0 0-.605-.605.61.61 0 0 0-.605.605c0 .33.275.605.605.605Z"
      fill="#919499"
    />
  </svg>
);
const Memo = memo(SvgQuickTipWhite);
export default Memo;
